import React from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import Navbar from "./Navbar";
import Home from "./Home";
import Features from "./Features";
import Pricing from "./Pricing";
import About from "./About";
import Login from "./Login";
import Signup from "./Signup";
import FAQ from "./FAQ";
import Download from "./Download";
import Privacy from "./Privacy";
import Button from "./Button";
import Timetable from "./Timetable";
import Contributors from "./Contributors";

function App() {
  return (
    <Router>
      <div className="App h-full w-full">
        <Navbar />
        <Routes>
          <Route
            path="/"
            element={
              <div>
                <Home />
                <Features />
                <Pricing />
                <FAQ />
                <About />
                <Button />
              </div>
            }
          />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/download" element={<Download />} />
          <Route path="/timetable" element={<Timetable />} />
          <Route path="/contributors" element={<Contributors />} />
          {/* <Route path="/download" element={document.location.href="https://vishal-lokare.github.io/test/AutoJoomer-beta.apk"} /> */}
          <Route path="*" element={<Navigate replace to="/" />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
